export const DATA_SET = 'ruleData.DATA_SET';
